import { useState } from 'react';
import { CHAT_CONSTANTS } from '../config/chat.constants';

declare global {
    interface Window {
        webkitSpeechRecognition: any;
    }
}

export const useVoiceRecognition = (
    onTranscript: (text: string) => void,
    notSupportedMessage: string
) => {
    const [isRecording, setIsRecording] = useState(false);

    const handleVoiceRecognition = () => {
        if (!('webkitSpeechRecognition' in window)) {
            alert(notSupportedMessage);
            return;
        }

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = 'pl-PL';
        recognition.continuous = true;
        recognition.interimResults = false;

        let idleTimeout: any;

        const resetIdleTimeout = () => {
            clearTimeout(idleTimeout);
            idleTimeout = setTimeout(() => {
                recognition.stop();
            }, CHAT_CONSTANTS.IDLE_TIMEOUT_MS);
        };

        recognition.onstart = () => {
            setIsRecording(true);
            resetIdleTimeout();
        };

        recognition.onend = () => {
            setIsRecording(false);
            clearTimeout(idleTimeout);
        };

        recognition.onresult = (event: any) => {
            const transcript = Array.from(event.results as any[])
                .map((result) => result[0].transcript)
                .join(' ');
            onTranscript(`${transcript}`.trim());
            resetIdleTimeout();
        };

        recognition.onerror = (event: any) => {
            console.error('Błąd rozpoznawania mowy:', event.error);
            setIsRecording(false);
            clearTimeout(idleTimeout);
        };

        recognition.start();
    };

    return { isRecording, handleVoiceRecognition };
};
